document.addEventListener("DOMContentLoaded", function () {
  const loginForm = document.getElementById("loginForm");
  const recoverForm = document.getElementById("recoverForm");
  const recoverEmailField = document.getElementById("RecoverEmail");
  const recoverSubmitButton = document.querySelector(
    '.recover_buttons button[type="submit"]'
  );
  const recoverTrigger = document.querySelector("a[href='#recover']");
  const returnToLoginLink = document.querySelector("a[href='#login']");
  const recoverSuccessMessage = document.getElementById("recover-success");

  const loginEmailField = document.getElementById("CustomerEmail");
  const loginPasswordField = document.getElementById("CustomerPassword");
  const loginSubmitButton = document.querySelector(
    '.login_buttons button[type="submit"]'
  );

  window.registerStrings = window.registerStrings || {};
  window.registerStrings.emptyEmail = "Please enter your email address.";
  window.registerStrings.invalidEmail = "Please enter a valid email address.";
  window.registerStrings.emptyPassword = "Please enter your password.";
  window.registerStrings.recoverSuccess =
    "If your account exists, you should receive an email in your mailbox.";

  // Clean up the stale flag left by the previous version so it can never
  // force the recovery form to show on future visits.
  try {
    localStorage.removeItem("showRecoverSuccess");
  } catch (e) {}

  /**
   * Show the recovery form ONLY when Shopify just posted/errored the recover
   * form (server-set window.__showRecover) or when deep-linked via #recover.
   * Default is always the Sign in form.
   */
  function shouldShowRecover() {
    if (window.__showRecover === true) return true;
    if (window.location.hash === "#recover") return true;
    return false;
  }

  function toggleForms() {
    if (shouldShowRecover()) {
      loginForm.classList.add("hidden");
      recoverForm.classList.remove("hidden");
      if (recoverSuccessMessage && window.__recoverSuccess === true) {
        recoverSuccessMessage.style.display = "block";
      }
    } else {
      loginForm.classList.remove("hidden");
      recoverForm.classList.add("hidden");
    }
  }

  // Run on page load
  toggleForms();

  /**
   * Clicking "Forgot your password?" should switch to the recovery form
   */
  if (recoverTrigger) {
    recoverTrigger.addEventListener("click", function (event) {
      event.preventDefault();
      window.__showRecover = true;
      loginForm.classList.add("hidden");
      recoverForm.classList.remove("hidden");
    });
  }

  /**
   * Clicking "Return to Login" should switch back to the login form
   */
  if (returnToLoginLink) {
    returnToLoginLink.addEventListener("click", function (event) {
      event.preventDefault();
      window.__showRecover = false;
      window.__recoverSuccess = false;
      loginForm.classList.remove("hidden");
      recoverForm.classList.add("hidden");
    });
  }

  /**
   * Validate email before submitting password recovery request
   */
  if (recoverSubmitButton) {
    recoverSubmitButton.addEventListener("click", function (event) {
      removeErrors(recoverEmailField);

      if (recoverEmailField.value.trim() === "") {
        displayError(recoverEmailField, window.registerStrings.emptyEmail);
        event.preventDefault();
      } else if (!validateEmail(recoverEmailField.value)) {
        displayError(recoverEmailField, window.registerStrings.invalidEmail);
        event.preventDefault();
      }
    });
  }

  /**
   * Validate login fields before submission
   */
  if (loginSubmitButton) {
    loginSubmitButton.addEventListener("click", function (event) {
      removeErrors(loginEmailField);
      removeErrors(loginPasswordField);

      let hasError = false;

      if (loginEmailField.value.trim() === "") {
        displayError(loginEmailField, window.registerStrings.emptyEmail);
        hasError = true;
      } else if (!validateEmail(loginEmailField.value)) {
        displayError(loginEmailField, window.registerStrings.invalidEmail);
        hasError = true;
      }

      if (loginPasswordField.value.trim() === "") {
        displayError(loginPasswordField, window.registerStrings.emptyPassword);
        hasError = true;
      }

      if (hasError) {
        event.preventDefault(); // Stop form submission if errors exist
      }
    });
  }

  /**
   * Display error message below the input field
   */
  function displayError(inputElement, message) {
    const errorElement = document.createElement("small");
    errorElement.classList.add("form_error", "dynamic-content");
    errorElement.innerHTML = `<span>${message}</span>`;
    inputElement.parentNode.appendChild(errorElement);
    inputElement.classList.add("error-border");
  }

  /**
   * Remove error messages
   */
  function removeErrors(inputElement) {
    const errorElements =
      inputElement.parentNode.querySelectorAll(".form_error");
    errorElements.forEach((error) => error.remove());
    inputElement.classList.remove("error-border");
  }

  /**
   * Validate email format
   */
  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
});
